import { Middleware, MiddlewareAPI } from "redux";

import {
	Activity,
	ActivityActions,
	ActivityMap,
	ActivitySelectors
} from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { ANTRAG_DETAIL_ACTIVITY_ID, TASK_DETAIL_ACTIVITY_ID } from "../../processOverview/store/actions";

export const handleCancelActionMiddleware: Middleware<unknown, { locale: Locale }> = api => next => {
	return action => {
		const result = next(action);

		if (
			ActivityActions.cancel.match(action) &&
			[TASK_DETAIL_ACTIVITY_ID, ANTRAG_DETAIL_ACTIVITY_ID].includes(action.payload.activityId)
		) {
			handleCancelAction(action.payload.activityId, api);
		}

		return result;
	};
};

function handleCancelAction(activityId: string, api: MiddlewareAPI) {
	const taskActivity = ActivitySelectors.activityById(TASK_DETAIL_ACTIVITY_ID)(api.getState());
	if (activityId === ANTRAG_DETAIL_ACTIVITY_ID && taskActivity) {
		api.dispatch(ActivityActions.cancel({ activityId: TASK_DETAIL_ACTIVITY_ID }));
	}

	if (activityId === TASK_DETAIL_ACTIVITY_ID) {
		reloadOverviewData(api);
		cancelAntragDetails(api);
	}
}

function reloadOverviewData(api: MiddlewareAPI): void {
	const topLevelActivities = ActivitySelectors.topLevelActivities()(api.getState());
	const topLevelActivityList = ActivityMap.toList(topLevelActivities);
	if (topLevelActivityList.length !== 1) {
		return;
	}
	const topLevelActivity = topLevelActivityList[0];
	if (topLevelActivity.lock) {
		return;
	}
	api.dispatch(ActivityActions.reloadData({ activityId: topLevelActivity.id }));
}

function cancelAntragDetails(api: MiddlewareAPI): void {
	const activity = ActivitySelectors.activityById(ANTRAG_DETAIL_ACTIVITY_ID)(api.getState());
	const dataHolder = Activity.findDefaultDataHolder(activity);

	if (!dataHolder?.dirty && activity) {
		api.dispatch(ActivityActions.cancel({ activityId: ANTRAG_DETAIL_ACTIVITY_ID }));
	}
}
